import {useCallback, useRef, useState} from 'react';
import './Gallery.scss';

const photos = [
  { id: 1, url: '/1disco.png', alt: 'Наша первая встреча' },
  { id: 2, url: '/2aeroport.png', alt: 'В аэропорту' },
  { id: 3, url: '/3merryinvite.png', alt: 'Предложение' },
  { id: 4, url: '/4civic.png', alt: 'Путешествие' },
  { id: 5, url: '/5house.png', alt: 'Наш дом' },
  { id: 6, url: '/6wedding.png', alt: 'Свадьба' },
];

const VISIBLE = 3;
const TOTAL_SLIDES = photos.length - VISIBLE + 1;

const getScrollPadding = () => (window.innerWidth <= 768 ? 38 : 58);

const Gallery = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const scrollerRef = useRef(null);

  const scrollToSlide = useCallback((index) => {
    const el = scrollerRef.current;
    if (!el) return;
    const slides = el.querySelectorAll('.gallery__slide');
    if (slides[index]) {
      el.scrollTo({ left: slides[index].offsetLeft - getScrollPadding(), behavior: 'smooth' });
    }
    setCurrentIndex(index);
  }, []);

  const handleScroll = useCallback(() => {
    const el = scrollerRef.current;
    if (!el) return;
    const padding = getScrollPadding();
    const slides = el.querySelectorAll('.gallery__slide');
    let closestIndex = 0;
    let closestDist = Infinity;
    slides.forEach((slide, i) => {
      const dist = Math.abs(slide.offsetLeft - padding - el.scrollLeft);
      if (dist < closestDist) {
        closestDist = dist;
        closestIndex = i;
      }
    });
    setCurrentIndex(Math.min(closestIndex, TOTAL_SLIDES - 1));
  }, []);

  return (
    <section className="gallery">
      <div className="gallery__header">
        <h2 className="gallery__title">Фото и видео</h2>
        <p className="gallery__subtitle">
          После свадьбы мы разместим видео и фотографии. Вы сможете посмотреть их и поделиться своими в беседе мессенджера Telegram. <br/> <br/> Чтобы туда попасть, нажмите на кнопку ниже.
        </p>
        <a href="https://t.me/+r1RhrENhDgljZmQy" className="gallery__btn" target="_blank" rel="noopener noreferrer">
          Перейти к беседе
        </a>
        <p className="gallery__subtitle">
          А профессиональные фотографии со свадьбы уже можно посмотреть в галерее нашего фотографа.
        </p>
        <a href="https://krauzov.com/v/gallery/vadim-i-dara-2cm8xg/" className="gallery__btn" target="_blank" rel="noopener noreferrer">
          Смотреть галерею
        </a>
      </div>

      <div
        ref={scrollerRef}
        className="gallery__scroller"
        onScroll={handleScroll}
      >
        {photos.map((photo) => (
          <div key={photo.id} className="gallery__slide">
            <img
              className="gallery__photo"
              src={photo.url}
              alt={photo.alt}
              loading="lazy"
              draggable={false}
              onError={(e) => {
                e.target.style.display = 'none';
              }}
            />
          </div>
        ))}
      </div>

      <div className="gallery__dots">
        {Array.from({ length: TOTAL_SLIDES }).map((_, i) => (
          <button
            key={i}
            className={`gallery__dot${i === currentIndex ? ' gallery__dot--active' : ''}`}
            onClick={() => scrollToSlide(i)}
            aria-label={`Слайд ${i + 1}`}
          />
        ))}
      </div>
    </section>
  );
};

export default Gallery;
